export const createGetOptionLabel = (keyField, column, data) => {
	return (row) => {
		if (!row || typeof row !== "object") return { key: row, name: String(row) };
		if (row.key !== undefined) return row;

		const actualKeyField = keyField || (column && data?.[column.key]);

		return {
			...row,
			key: row[actualKeyField] || "",
			name: row[actualKeyField] || "",
		};
	};
};
